import React from "react";

import TypeRadioGroup from "./TypeRadioGroup";
import { cn } from "../../../../lib/utils";
import {Popover, PopoverContent, PopoverTrigger} from "../../ui/Popover";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/pro-solid-svg-icons";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "../../ui/Form";
import {Input} from "../../ui/Input";

const Type = ({ methods, isOpen: { Type } }) => {
    const { control,watch } = methods;

    const current_configuration = watch("configuration");

    return (
        <div
            className={cn(
                "section flex flex-col gap-6  overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: Type.isOpen,
                }
            )}
        >
            <div className='grid grid-cols-4'>
                <TypeRadioGroup {...methods} />
            </div>

            {current_configuration !== 'none' && (
                <div className='flex flex-col gap-2'>
                    <div className='relative py-2'>
                        <div className="absolute top-1 left-0 w-full h-full z-10">
                            <Popover>
                                <PopoverTrigger>
                                    <FontAwesomeIcon className="text-primary absolute top-0 left-0"
                                                     icon={faCircleInfo}/>
                                </PopoverTrigger>
                                <PopoverContent className='text-center'>The aperture is the total opening size. You can measure this by measuring the external face of the opening from side to side, and top to bottom, including the space which the cill occupies</PopoverContent>
                            </Popover>
                        </div>
                    </div>
                    <FormField
                        control={control}
                        name="aperture_width"
                        render={({field}) => (
                            <FormItem>
                                <FormLabel className="text-gray-700">
                                    Aperture Width
                                    <span className="text-sm text-primary">(mm)</span>
                                </FormLabel>
                                <FormControl>
                                    <Input
                                        type="number"
                                        icon
                                        className="text-gray-700"
                                        placeholder="Enter Aperture Width"
                                        {...field}
                                    />
                                </FormControl>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={control}
                        name="aperture_height"
                        render={({field}) => (
                            <FormItem>
                                <FormLabel className="text-gray-700">
                                    Aperture Height
                                    <span className="text-sm text-primary">(mm)</span>
                                </FormLabel>
                                <FormControl>
                                    <Input
                                        type="number"
                                        icon
                                        className="text-gray-700"
                                        placeholder="Enter Aperture Height"
                                        {...field}
                                    />
                                </FormControl>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />

                </div>
            )}

        </div>
    );
};

export default Type;
